import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import { ArrowRight, Filter, ArrowUpRight, ArrowDownRight, Info } from 'lucide-react';
import { motion } from 'framer-motion';
export function OrderFunnelChart() {
  const funnelData = [{
    stage: 'Received',
    count: 27396,
    prevCount: 24500,
    percentage: 100,
    color: 'bg-slate-900',
    description: 'Total orders received by the system'
  }, {
    stage: 'Rejected',
    count: 16253,
    prevCount: 14800,
    percentage: 59.3,
    color: 'bg-red-500',
    description: 'Orders rejected by branches or system'
  }, {
    stage: 'Accepted',
    count: 11143,
    prevCount: 9700,
    percentage: 40.7,
    color: 'bg-blue-500',
    description: 'Orders accepted for processing'
  }, {
    stage: 'Allocated',
    count: 6320,
    prevCount: 5800,
    percentage: 23.1,
    color: 'bg-purple-500',
    description: 'Orders allocated to specific fulfillment paths'
  }, {
    stage: 'Completed',
    count: 3768,
    prevCount: 3400,
    percentage: 13.8,
    color: 'bg-emerald-500',
    description: 'Orders successfully delivered or picked up'
  }];
  return <Card className="h-full" data-id="element-59">
      <CardHeader className="flex flex-row items-center justify-between pb-2" data-id="element-60">
        <CardTitle className="text-base font-semibold" data-id="element-61">Order Funnel</CardTitle>
        <Filter className="w-4 h-4 text-slate-400" data-id="element-62" />
      </CardHeader>
      <CardContent data-id="element-63">
        <div className="flex flex-col space-y-6 mt-4" data-id="element-64">
          {funnelData.map((step, idx) => {
          const change = step.prevCount > 0 ? Math.round((step.count - step.prevCount) / step.prevCount * 100) : 0;
          const isPositive = change >= 0;
          return <div key={step.stage} className="relative" data-id="element-65">
                <div className="flex justify-between items-end mb-1" data-id="element-66">
                  <div className="flex items-center gap-1.5" data-id="element-67">
                    <span className="text-sm font-medium text-slate-700" data-id="element-68">
                      {step.stage}
                    </span>
                    <Info className="w-3 h-3 text-slate-300 cursor-help" data-id="element-69" />
                  </div>
                  <div className="flex items-center gap-2" data-id="element-70">
                    <div className="text-right" data-id="element-71">
                      <span className="text-sm font-bold text-slate-900" data-id="element-72">
                        {step.count.toLocaleString()}
                      </span>
                      <span className="text-xs text-slate-400 ml-2" data-id="element-73">
                        ({step.percentage}%)
                      </span>
                    </div>
                  </div>
                </div>
                <div className="w-full bg-slate-50 rounded-full h-2.5 overflow-hidden border border-slate-100" data-id="element-74">
                  <motion.div initial={{
                width: 0
              }} animate={{
                width: `${step.percentage}%`
              }} transition={{
                duration: 1,
                ease: 'easeOut'
              }} className={`h-full rounded-full ${step.color}`} data-id="element-75" />
                </div>
                {idx < funnelData.length - 1 && <div className="absolute -bottom-5 left-4 text-slate-200" data-id="element-76">
                    <ArrowRight className="w-3.5 h-3.5 rotate-90" data-id="element-77" />
                  </div>}
              </div>;
        })}
        </div>
      </CardContent>
    </Card>;
}